import EditPageTemplateDialog from './EditPageTemplateDialog'
export default EditPageTemplateDialog
export * from './EditPageTemplateDialog'
